var map = {
	"./Daigoji.png": 801,
	"./dera.png": 792,
	"./higa.png": 260,
	"./kinkaku.png": 40,
	"./konzoji.png": 966,
	"./map.png": 468,
	"./nijo.png": 994,
	"./phoyo (1).png": 586,
	"./sake.png": 543,
	"./ternryu.png": 76,
	"./toji.png": 654,
	"./vidbackup.jpg": 394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;